import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AudienceTab() {
  const [days, setDays] = useState(30);
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/admin/audience", { params: { days } }).then((r) => setD(r.data)).catch(() => {});
  }, [days]);
  const max = Math.max(1, ...(d?.per_day || []).map((x) => x.views));

  return (
    <div data-testid="audience-tab">
      <div className="flex flex-wrap gap-3">
        {[7, 30, 90].map((n) => (
          <button key={n} onClick={() => setDays(n)} data-testid={`audience-${n}`}
            className={`px-5 py-2 text-[11px] uppercase tracking-[0.2em] ${days === n ? "bg-brass text-ink" : "border border-white/15 text-bone/70"}`}>
            {n} jours
          </button>
        ))}
      </div>
      {d && (
        <>
          <div className="mt-5 grid gap-4 sm:grid-cols-2">
            <div className="border border-white/10 bg-panel p-5">
              <p className="font-display text-3xl text-bone" data-testid="audience-views">{d.views}</p>
              <p className="mt-1 text-xs text-muted-foreground">Pages vues</p>
            </div>
            <div className="border border-white/10 bg-panel p-5">
              <p className="font-display text-3xl text-bone" data-testid="audience-visitors">{d.visitors}</p>
              <p className="mt-1 text-xs text-muted-foreground">Visiteurs uniques</p>
            </div>
          </div>
          <div className="mt-5 border border-white/10 bg-panel p-5">
            <p className="text-xs uppercase tracking-wider text-muted-foreground">Fréquentation</p>
            <div className="mt-4 flex h-28 items-end gap-1">
              {d.per_day.map((x) => (
                <div key={x.day} title={`${x.day} — ${x.views}`} className="flex-1 bg-brass/70"
                  style={{ height: `${Math.round((x.views / max) * 100)}%`, minHeight: 2 }} />
              ))}
              {!d.per_day.length && <p className="text-sm text-muted-foreground">Aucune visite enregistrée.</p>}
            </div>
          </div>
          <div className="mt-5 grid gap-4 lg:grid-cols-3">
            <div className="border border-white/10 bg-panel p-5">
              <p className="text-xs uppercase tracking-wider text-muted-foreground">Pages les plus vues</p>
              {d.top_pages.map((p) => (
                <div key={p.path} className="flex justify-between border-b border-white/10 py-2 text-sm">
                  <span className="text-bone/80">{p.path}</span><span>{p.views}</span>
                </div>
              ))}
            </div>
            <div className="border border-white/10 bg-panel p-5" data-testid="audience-sources">
              <p className="text-xs uppercase tracking-wider text-muted-foreground">Sources de trafic</p>
              {(d.top_sources || []).map((p) => (
                <div key={p.source} className="flex justify-between border-b border-white/10 py-2 text-sm">
                  <span className="truncate text-bone/80">{p.source}</span><span className="pl-3">{p.views}</span>
                </div>
              ))}
            </div>
            <div className="border border-white/10 bg-panel p-5">
              <p className="text-xs uppercase tracking-wider text-muted-foreground">Provenances</p>
              {d.top_referrers.map((p) => (
                <div key={p.ref} className="flex justify-between border-b border-white/10 py-2 text-sm">
                  <span className="truncate text-bone/80">{p.ref}</span><span className="pl-3">{p.views}</span>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
